const toNumber = (value) => {
  if (value === null || value === undefined) return 0;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  const cleaned = String(value).replace(/[^0-9.-]/g, "");
  const parsed = Number(cleaned);
  return Number.isFinite(parsed) ? parsed : 0;
};

export function calcularVariacionMunicipios(response) {
  if (!response?.items || !Array.isArray(response.items)) {
    return [];
  }

  const data = response.items;
  const porMunicipio = {};

  data.forEach(({ municipio, mes, cantidad }) => {
    if (!porMunicipio[municipio]) {
      porMunicipio[municipio] = [];
    }

    porMunicipio[municipio].push({
      mes,
      valor: toNumber(cantidad),
    });
  });

  const filas = [];

  Object.entries(porMunicipio).forEach(([municipio, registros]) => {
    registros.sort((a, b) => a.mes.localeCompare(b.mes));

    registros.forEach((actual, index) => {
      const anterior = registros[index - 1];

      let variacion = 0;

      if (anterior) {
        if (anterior.valor === 0 && actual.valor > 0) {
          variacion = 100; // arranque
        } else if (anterior.valor > 0 && actual.valor === 0) {
          variacion = -100; // caída total
        } else if (anterior.valor === 0 && actual.valor === 0) {
          variacion = 0;
        } else {
          variacion = Number(
            (((actual.valor - anterior.valor) / anterior.valor) * 100).toFixed(2)
          );
        }
      }

      let semaforo = "AMARILLO";
      if (variacion > 5) semaforo = "VERDE";
      if (variacion < -5) semaforo = "ROJO";

      filas.push({
        municipio,
        mes: actual.mes,
        valor: actual.valor,
        variacion,
        semaforo,
      });
    });
  });

  return filas;
}
